// extracted by mini-css-extract-plugin
module.exports = {"sm":"Icon_sm__Smpn8","md":"Icon_md__tTvyI","lg":"Icon_lg__ZX8oU","xl":"Icon_xl__sWZ9N"};